import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip, Typography } from '@mui/material'
import { useSmartTranslation } from '../../../../../../../generic/hooks/useSmartTranslation'
import { isInferred, provenanceTooltipKey } from '../../../utils/jobDetailFootprint'

// Historia 169 (RN11, POL-F1) — la marca "(deducido)" con el tooltip que explica de dónde sale el
// dato (tramo de operario / reporte de cantidad / puesto que ejecutó la pieza). `REGISTERED` (o
// ausente) no pinta nada: solo se marca lo que NO es un dato registrado (S63).
//
// H21/B-J14 (2026-09-27, FIRMADO — S72, hub e049d60): a diferencia de los CHIPS de estado (UX-8, que sí
// van en mayúsculas por diseño, `Pill`), esta marca vive DENTRO de la frase de estado como texto normal
// — nunca "DEDUCIDO": conserva la capitalización real del valor de la clave "Inferred" ("Deducido").

const ProvenanceMark = ({ provenance = '', testId = '' }) => {
  const { t_ } = useSmartTranslation()
  if (!isInferred(provenance)) return null
  return (
    <Tooltip title={t_(provenanceTooltipKey(provenance))} disableInteractive>
      <Typography
        component='span'
        data-testid={testId || undefined}
        sx={{ ml: 0.75, fontSize: '0.7rem', fontWeight: 700, letterSpacing: '0.04em', color: 'text.secondary' }}
      >
        {t_('Inferred')}
      </Typography>
    </Tooltip>
  )
}

ProvenanceMark.propTypes = { provenance: PropTypes.string, testId: PropTypes.string }

export default ProvenanceMark
